import React, { useEffect, useState } from 'react';
import {
  OverlayTrigger,
  PopOver,
  Switch,
} from '@tencent/spaui';
import { RPCFactory } from '../../utils/RequestUtil';
import { PageUtil } from '../../utils/PageUtil';

const LeadsDedupPartInner = (props) => {
  const leadsDedupStatus = PageUtil.getLeadsDedupFromStorage();
  const [hideRepeatRegisterLeads, setHideRepeatLeads] = useState(leadsDedupStatus);
  const updateDedupStatus = (newStatus) => {
    if (newStatus !== hideRepeatRegisterLeads) {
      setHideRepeatLeads(!!newStatus);
      PageUtil.setLeadsDedupToStorage(!!newStatus);
    }
  }
  useEffect(() => {
    RPCFactory.leadsManage.getUniqueStatus()
      .done((data) => {
        updateDedupStatus(data);
      });
  }, []);
  const onCheckedChange = (e, checked) => {
    updateDedupStatus(!!checked);
    RPCFactory.leadsManage.setUniqueStatus(!!checked);
    if (props.onChange) {
      props.onChange(!!checked);
    }
  };
  const title = props.title || '线索去重';
  const tip = props.tip || '开启按钮后，线索列表将不再展示带有“电话重复”标签的线索';
  return (
    <div className="repeat-tips">
      <span className='dedup-title'>{title}</span>
      <OverlayTrigger
        trigger="hover"
        alignment="right"
        overlay={
          <PopOver>
            {tip}
          </PopOver>
        }
      >
        <i className="icon icon-help" style={{ marginRight: 8 }} />
      </OverlayTrigger>
      <Switch
        style={{ verticalAlign: '-3px', marginRight: '4px', lineHeight: 1 }}
        checked={hideRepeatRegisterLeads}
        onChange={onCheckedChange}
      ></Switch>
    </div>
  );
};
export const LeadsDedupPart = React.memo(LeadsDedupPartInner);
